import api from "@/lib/api";

const SW_URL = "/sw-push.js";

export function pushSupported() {
    return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = window.atob(base64);
    const out = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
    return out;
}

export async function getSubscriptionState() {
    if (!pushSupported()) return "unsupported";
    if (Notification.permission === "denied") return "denied";
    const reg = await navigator.serviceWorker.getRegistration(SW_URL);
    const sub = reg ? await reg.pushManager.getSubscription() : null;
    return sub ? "subscribed" : "unsubscribed";
}

export async function enablePush() {
    if (!pushSupported()) throw new Error("Push notifications are not supported on this device or browser.");
    const permission = await Notification.requestPermission();
    if (permission !== "granted") throw new Error("Notification permission was not granted.");
    const reg = await navigator.serviceWorker.register(SW_URL);
    await navigator.serviceWorker.ready;
    const { data } = await api.get("/push/vapid-public-key");
    if (!data.public_key) throw new Error("Push is not configured on the server.");
    const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
    const json = sub.toJSON();
    await api.post("/push/subscribe", {
        endpoint: json.endpoint,
        keys: json.keys,
        user_agent: navigator.userAgent,
    });
    return true;
}

export async function disablePush() {
    const reg = await navigator.serviceWorker.getRegistration(SW_URL);
    const sub = reg ? await reg.pushManager.getSubscription() : null;
    if (sub) {
        await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
        await sub.unsubscribe().catch(() => {});
    }
    return true;
}

// Silently (re)subscribe a returning member whose browser already granted permission.
export async function autoEnablePush() {
    if (!pushSupported() || Notification.permission !== "granted") return false;
    if ((await getSubscriptionState()) === "subscribed") return true;
    try { await enablePush(); return true; } catch (e) { return false; }
}
